const listColumn = {
  TICKER: 'ticker',
  PRICE: 'matchPrice',
  VOLUME: 'totalMatchVolume',
  AVG_VOLUME: 'averageMatchVolume2Week',
  VOLUME_CE_UNMATCHED: 'volumeCEUnmatched',
  VOLUME_CE_FL_UNMATCHED: 'volumeCEFLUnmatched',
  VOLUME_FL_UNMATCHED: 'volumeFLUnmatched',
  RATIO: 'ratio',
  SESSION: 'session',
  PREV_SESSION: 'previouseSession',
  RANK: 'rank',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
  TOTALRANK: 'totalRank',
};

const listHideColumn = [
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
  'priceChange',
  'volumeCEUnmatched',
  'volumeFLUnmatched',
  'totalRank',
];

const filterAbnormalityType = {
  1: {
    text: 'CeilingBuy',
    quote: 'tasignals.abnormalityContent.filter_quote_1',
  },
  2: {
    text: 'FloorSell',
    quote: 'tasignals.abnormalityContent.filter_quote_2',
  },
};

const filterAvgVolume = {
  1: '10000',
  2: '50000',
  3: '100000',
  4: '300000',
  5: '500000',
};

const filterRate = {
  1: '0.5',
  2: '0.8',
  3: '1',
  4: '1.2',
  5: '1.5',
};

export default {
  listColumn,
  listHideColumn,
  filterAbnormalityType,
  filterAvgVolume,
  filterRate,
};
